import React from 'react';
import Slider from '../components/Slider/Slider';
import About from '../components/About/About';
import Services from '../components/Services/Services';
import WhyChooseUs from "../components/WhyChooseUs/WhyChooseUs";
import Stats from '../components/Stats/Stats';
import Companies from '../components/Companies/Companies';
import Team from '../components/Team/Team';
import ClientStories from '../components/ClientStories/ClientStories'; 
import FAQ from '../components/FAQ/FAQ';
import Contact from '../components/Contact/Contact';
//import Footer from '../components/Footer/Footer'

const Home = () => {
  return (
    <>
      <Slider />
      <About />
      <Services />
      <WhyChooseUs />
      <Stats />
      <Companies />
      <Team />
      <ClientStories /> 
      <FAQ />
      <Contact />
      {/* <Footer /> */}
    </>
  );
};

export default Home;
